import BreadcrumbsStateless, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { CodeclouUrlParameter } from '../../components/util/url-encoding-helper';
import { GlobalContext } from '../common/GlobalContext';
import { CepLogo } from './CepLogo';
import { CCLoadingPlaceholder } from 'components/ui/CCLoadingPlaceholder';
import { CepHelpDialog } from './CepHelpDialog';
import Tooltip from '@atlaskit/tooltip';
import getGitCommitHashVersion from 'version';

// Originally taken from https://github.com/codeclou/customfield-editor-plugin-frontend-react

const HelpLogoSpacer = styled.div`
  margin-right: 8px;
  margin-top: 4px;
`;
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: -10px;
`;
const HeaderColLeft = styled.div`
  margin-top: 0px;
  margin-bottom: 5px;
`;
const HeaderColRight = styled.div``;

const CepLogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-top: 10px;
`;
const CepLogoContainerInner = styled.div`
  padding-top: 3px;
`;

export const PageTitle = styled.div`
  font-size: 22px;
  font-weight: 500;
`;

// const PageHeaderSubTitle = styled.div`
//  margin-top: -27px;
//  margin-bottom: 30px;
//  color: #999;
// `;

export const CepPageHeader = ({
  pageTitle,
  breadcrumbItems,
  isLoading,
  helpUri,
  helpContent,
  useNavigate,
}: {
  pageTitle?: string;
  breadcrumbItems: TBreadcrumbsItem[];
  helpContent: React.ReactNode;
  helpUri: string;
  useNavigate: any;
  isLoading: boolean;
}) => {
  const { t, encodeUriSafe } = useContext(GlobalContext);
  const navigate = useNavigate();

  const breadcrumbs = (
    <div data-e2e-page-breadcrumbs="true">
      <BreadcrumbsStateless isExpanded={true}>
        {breadcrumbItems.map((value: TBreadcrumbsItem, index: number) => {
          const valy = value.text ? value.text : value.i18n ? t(value.i18n) : '';
          return (
            <BreadcrumbsItem
              key={'brdcrm-' + index}
              href={encodeUriSafe(value.href, value.params, true)}
              onClick={(e: React.MouseEvent<any>) => {
                e.preventDefault();
                navigate(encodeUriSafe(value.href, value.params, false));
              }}
              text={valy}
            />
          );
        })}
      </BreadcrumbsStateless>
    </div>
  );
  return (
    <>
      <HeaderContainer>
        <HeaderColLeft>
          {breadcrumbs}
          <PageTitle data-e2e-page-title="true">
            {/* NOT DEPENDING ON isLoading since some pages have fixed pagetitle even when page is laoding! */ pageTitle ? pageTitle : <CCLoadingPlaceholder width={300} height={35} />}
          </PageTitle>
        </HeaderColLeft>
        <HeaderColRight>
          <CepLogoContainer>
            <HelpLogoSpacer>
              <CepHelpDialog helpContent={helpContent} helpUri={helpUri} />
            </HelpLogoSpacer>
            <CepLogoContainerInner>
              <Tooltip position="top-start" content={<>version: {getGitCommitHashVersion()}</>}>
                <div>
                  <CepLogo />
                </div>
              </Tooltip>
            </CepLogoContainerInner>
          </CepLogoContainer>
        </HeaderColRight>
      </HeaderContainer>
    </>
  );
};

export class TBreadcrumbsItem {
  constructor(public href: string, public params: CodeclouUrlParameter[], public i18n?: string, public text?: string, public icon?: React.ReactNode) {}
}
